<template>
  <div>
    <b-row>
        <b-col md="1">
        </b-col>
        <b-col md="10" align-self="center">
            <b-form @submit="createPayment()">
                <b-form-group label-align="right" :label="$t('Payment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="number" v-model="paymentData.payment_incurrency" pattern="\d+(\.\d{2})?"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-select id="currencies"
                        :options="currencies"
                        required
                        v-model="paymentData.currency_id">
                    </b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Payment date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <flat-picker
                    @onDateChanged="(unixDate) => {actual_date = unixDate}"
                    @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(actual_date ? actual_date : new Date()/1000 ).toDate())}"
                    />
                    <b-form-checkbox v-model="isSetBurnTime">{{ $t('Set burn time') }}</b-form-checkbox>
                </b-form-group>
                <b-form-group label-align="right" v-if="isSetBurnTime" :label="$t('Burn date')" label-cols="4" label-cols-xl="4" label-cols-md="4">

                    <flat-picker
                    @onDateChanged="(unixDate) => {burn_time = unixDate}"
                    @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(burn_time ? burn_time : new Date()/1000 ).toDate())}"
                    />
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Payment method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-select id="method"
                        :options="methods"
                        required
                        v-model="paymentData.method">
                    </b-form-select>
                </b-form-group>
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-payment-settings variant="outline-sucess">{{ $t('OtherSettings') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-payment-settings" accordion="accordion-payment-settings" role="tabpanel">
                    <b-card-body>
                      <b-form-group label-align="right" :label="$t('Admin comment')" label-cols="5" label-cols-xl="5" label-cols-md="5">
                    <b-form-input type="text" v-model="paymentData.admin_comment"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-input type="text" v-model="paymentData.comment"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Payment extern number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-input type="text" v-model="paymentData.payment_ext_number"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Invoice number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-input-group>
                            <b-form-input type="number" v-model="paymentData.payment_to_invoice" disabled/>
                            <b-input-group-append>
                                <b-btn size="sm" @click="showModal()" variant="success">{{ $t('Invoices') }}</b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Turn on inet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-checkbox v-model="paymentData.turn_on_inet"></b-form-checkbox>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Write out a receipt')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-checkbox v-model="isTypeReceipt"></b-form-checkbox>
                    </b-form-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <modal-ok-cancel @save="createPayment()" @cancel="close()" size="md"/>
            </b-form>
        </b-col>
    </b-row>

    <b-modal ref="myModalRef" hide-footer
    >
      <Invoices v-if="isShowInvoices" :userId="userId" :accountId="accountId" @clickOnInvoice="clickOnInvoice" ></Invoices>
      <b-btn class="mt-3" variant="secondary" block @click="hideModal">{{ $t('Cancel') }}</b-btn>
    </b-modal>
  </div>
</template>

<style>
.b-input-group {
    padding: 10px
}
</style>

<script>
import Invoices from '@/pages/reports/Invoices.vue'
import download from 'downloadjs'
import moment from 'moment'
export default {
  components: {
    Invoices
  },
  props: {
    accountId: null,
    userId: null
  },
  data () {
    return {
      paymentData: {
        'account_id': 0,
        'user_id': 0,
        'payment_incurrency': 0.0,
        'currency_id': 810,
        'actual_date': 0,
        'burn_time': 0,
        'method': 1,
        'admin_comment': '',
        'comment': '',
        'payment_ext_number': '',
        'payment_to_invoice': 0,
        'turn_on_inet': 0
      },
      fileName: '.Receipt',
      isTypeReceipt: false,
      isShowInvoices: false,
      isSetBurnTime: false,
      actual_date: moment().unix(),
      burn_time: moment().unix(),
      errorTitle: null,
      errorContent: null,
      secInDay: 86400
    }
  },
  methods: {
    close () {
      this.$emit('close', null)
    },
    async createPayment () {
      if (!this.paymentData.method) {
        this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Check payment method'), 'Warning')
        return
      }
      this.paymentData.payment_incurrency = Number(this.paymentData.payment_incurrency)
      if (this.paymentData.payment_incurrency === 0) {
        this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Check payment amount'), 'Warning')
      } else {
        this.paymentData.account_id = this.accountId
        this.paymentData.user_id = this.userId
        this.paymentData.actual_date = this.actual_date
        if (this.isSetBurnTime) {
          this.paymentData.burn_time = this.burn_time
        } else {
          this.paymentData.burn_time = 0
        }
        let response = this.$store.dispatch('Tariffing/CREATE_PAYMENT', this.paymentData)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts', 'success', this.$i18n.t('Payment added'))
            this.$emit('load')
            this.close()

            if (this.isTypeReceipt && response.data.payment_transaction_id) {
              this.fileName += '.pdf'
              let payload = {
                user_id: this.userId,
                base_id: response.data.payment_transaction_id
              }
              let respDoc = this.$store.dispatch('Users/GET_DOCUMENT', payload)
              respDoc.then(response => {
                download(response.data, this.fileName, 'application/pdf')
              })
            }
          }
        })
      }
    },
    clickOnInvoice (invoiceId) {
      this.$refs.myModalRef.hide()
      this.paymentData.payment_to_invoice = invoiceId
      this.isShowInvoices = false
    },
    showModal () {
      this.isShowInvoices = true
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.isShowInvoices = false
      this.$refs.myModalRef.hide()
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters['Users/FULL_INFO_USERS']
    },
    currencies () {
      let tmp = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        let newEl = {
          value: el.currency_id,
          text: el.currency_brief_name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    methods () {
      let tmp = []
      for (let el of this.$store.getters['ReferenceBooks/PAYMENT_METHODS']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    sysCurrency () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS_SYS_CURRENCY']
    }

  },
  watch: {
    sysCurrency: function (val) {
      if (!this.userInfo.binded_currency_id) {
        this.paymentData.currency_id = val
      }
    },
    userInfo: function (val) {
      this.paymentData.currency_id = val.binded_currency_id
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS_SYSTEM_CURRENCY')
    this.$store.dispatch('Users/GET_FULL_INFO_USERS', this.userId)
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('ReferenceBooks/GET_PAYMENT_METHODS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/formPayment.vue